// eslint-disable-next-line import/no-cycle
import { getApi, postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		verification: null,
	}),
	mutations: {
		SET_VERIFICATION_DATA(state, val) {
			state.verification = val;
		},
		DEL_VERIFICATION_DOC(state, uid) {
			state.verification.documents = state.verification.documents.filter((doc) => doc.uid !== uid);
		},
		SET_VERIFICATION_DOC(state, val) {
			// console.log('val:', val);
			// state.verification.documents.filter((doc) => {
			// 	console.log('doc.document_type.uid:', doc.document_type.uid);
			// 	console.log('val.document_type.uid:', val.document_type.uid);
			// 	return doc.uid !== val.uid;
			// });
			console.log('SET_VERIFICATION_DOC');
			const doc = state.verification.documents.filter((docItem) => docItem.document_type.uid !== val.document_type.uid);
			// console.log('12345', doc);
			doc.push(val);
			// console.log('12345 after push:', doc);
			console.log('SET_VERIFICATION_DOC End', doc);
			state.verification.documents = doc;
		},
	},
	actions: {
		async uploadDocument(_, data) {
			const response = await postApi('/k5/v1/loan-app/verification/upload-document', data);
			return response;
		},
		async initPassportVerification() {
			const response = await postApi('/k5/v1/loan-app/verification/init', {
				procedure_slug: 'passport_and_reg_address',
			});
			return response;
		},
		async getPassportVerification() {
			const response = await getApi('/k5/v1/loan-app/verification/get-verification?procedure_slug=passport_and_reg_address');
			return response;
		},
		async getPassportDocument(_, docUid) {
			const response = await postApi('/k5/v1/loan-app/verification/get-document', {
				document_uid: docUid,
				preview: true,
			});
			return response;
		},
		async deletePassportDocument(_, docUid) {
			const response = await postApi('/k5/v1/loan-app/verification/delete-document', {
				document_uid: docUid,
			});
			return response;
		},
	},
	getters: {},
};
